import { useEffect, useState } from "react";
import api from "../../lib/api";
import { Button } from "../../components/ui/button";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../../components/ui/dialog";
import { Plus, Trash2, KeyRound, ShieldCheck } from "lucide-react";
import { toast } from "sonner";

export default function AdminUsers() {
  const [users, setUsers] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ email: "", password: "", role: "admin" });
  const [pwOpen, setPwOpen] = useState(null);
  const [newPw, setNewPw] = useState("");

  const load = () => api.get("/admin/users").then((r) => setUsers(r.data));
  useEffect(() => { load(); }, []);

  const create = async (e) => {
    e.preventDefault();
    try {
      await api.post("/admin/users", form);
      toast.success("Kullanıcı oluşturuldu");
      setOpen(false); setForm({ email: "", password: "", role: "admin" }); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Hata"); }
  };

  const del = async (id) => {
    if (!window.confirm("Silinsin mi?")) return;
    try {
      await api.delete(`/admin/users/${id}`);
      toast.success("Silindi"); load();
    } catch (err) { toast.error(err?.response?.data?.detail || "Hata"); }
  };

  const changePw = async () => {
    try {
      await api.put(`/admin/users/${pwOpen}/password`, { new_password: newPw });
      toast.success("Şifre güncellendi");
      setPwOpen(null); setNewPw("");
    } catch (err) { toast.error(err?.response?.data?.detail || "Hata"); }
  };

  return (
    <div className="p-8 max-w-5xl" data-testid="admin-users">
      <div className="flex items-center justify-between mb-6">
        <h1 className="heading-serif text-3xl font-semibold text-navy">Yönetici Kullanıcılar</h1>
        <Button onClick={() => setOpen(true)} className="bg-gold hover:bg-[#c49d58]" data-testid="admin-user-new">
          <Plus size={16} className="mr-1" /> Yeni Yönetici
        </Button>
      </div>

      <div className="bg-white rounded-xl overflow-hidden border border-gray-100">
        <table className="w-full text-sm">
          <thead className="bg-softbg text-xs uppercase tracking-wider text-gray-500">
            <tr>
              <th className="text-left p-3">E-posta</th>
              <th className="text-left p-3">Rol</th>
              <th className="text-left p-3">Eklenme</th>
              <th className="text-right p-3">İşlem</th>
            </tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id} className="border-t border-gray-100">
                <td className="p-3 font-medium text-navy">{u.email}</td>
                <td className="p-3">
                  <span className="inline-flex items-center gap-1 text-xs bg-softbg rounded-full px-2 py-0.5">
                    {u.role === "super_admin" && <ShieldCheck size={11} className="text-gold" />}
                    {u.role}
                  </span>
                </td>
                <td className="p-3 text-xs text-gray-500">{(u.created_at || "").slice(0, 10)}</td>
                <td className="p-3 text-right">
                  <button onClick={() => setPwOpen(u.id)} className="p-1.5 text-gray-500 hover:text-teal" title="Şifreyi değiştir" data-testid={`admin-user-pw-${u.email}`}>
                    <KeyRound size={14} />
                  </button>
                  <button onClick={() => del(u.id)} className="p-1.5 text-gray-500 hover:text-rose-600" data-testid={`admin-user-delete-${u.email}`}>
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md">
          <DialogHeader><DialogTitle className="heading-serif">Yeni Yönetici</DialogTitle></DialogHeader>
          <form onSubmit={create} className="space-y-3">
            <div><Label className="text-xs">E-posta</Label><Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} required /></div>
            <div><Label className="text-xs">Şifre (min 8 karakter)</Label><Input type="password" minLength={8} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} required /></div>
            <div><Label className="text-xs">Rol</Label>
              <select className="w-full border rounded-md h-10 px-3 bg-softbg text-sm" value={form.role} onChange={(e) => setForm({ ...form, role: e.target.value })}>
                <option value="admin">Admin</option>
                <option value="super_admin">Super Admin</option>
              </select>
            </div>
            <div className="flex justify-end gap-2 pt-2 border-t">
              <Button type="button" variant="ghost" onClick={() => setOpen(false)}>Vazgeç</Button>
              <Button type="submit" className="bg-gold hover:bg-[#c49d58]">Oluştur</Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Dialog open={!!pwOpen} onOpenChange={(v) => !v && setPwOpen(null)}>
        <DialogContent className="max-w-sm">
          <DialogHeader><DialogTitle className="heading-serif">Şifre Değiştir</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div><Label className="text-xs">Yeni Şifre</Label><Input type="password" minLength={8} value={newPw} onChange={(e) => setNewPw(e.target.value)} /></div>
            <div className="flex justify-end gap-2">
              <Button variant="ghost" onClick={() => setPwOpen(null)}>Vazgeç</Button>
              <Button onClick={changePw} className="bg-gold hover:bg-[#c49d58]">Güncelle</Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
}
